import React from 'react';
import NewFicheForm from "../../../components/Forms/Fiche/NewFicheForm";
import {makeStyles} from "@material-ui/core/styles";
import {STORE_FICHE, UPDATE_FICHE} from "../../../api/Api";
import axios from "axios";
import {useHistory} from "react-router-dom";
import {generateRandomString} from "../../../utils/helpers";


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1,1)
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(5,12)
        },
        [theme.breakpoints.up('lg')]: {
            padding: theme.spacing(10,20)
        },
    },
    table: {
        minWidth: 700,
    },
    title: {
        marginBottom: 100
    }
}));



export default function UnauthenticatedNewFichePage(props){

    const classes = useStyles();

    const [isSubmitting,setIsSubmitting] = React.useState(false);
    const [isMailValided,setIsMailValided] = React.useState(false);
    const [formValues,setFormValues] = React.useState({});


    const [step,setStep] = React.useState('formulaire');

    const history = useHistory();

    const formCode = React.useMemo(()=>{
        return generateRandomString(5)
    },[])

    async function submitForm(values){
        setIsSubmitting(true);
        setFormValues(values)
        const {lat_lng,...otherValues} = values;

        const finalValues = {
            ...otherValues,
            geo_lat: lat_lng.lat,
            geo_lng: lat_lng.lng,
            form_code: formCode
        };

        try{

           const response = await axios.post(
               STORE_FICHE,
               finalValues
           );

            // history.push(`/fiches/email/validation/${response.data.form_code}`);
            history.push(`/fiches/recapitulatif/${response.data.code}`);


        } catch (e) {
            console.log(e);
        } finally {
            setIsSubmitting(false);

        }

    }


    async function updateFiche(ficheData,values){

        setIsSubmitting(true);
        setFormValues(values)
        const {lat_lng,...otherValues} = values;

        const finalValues = {
            ...otherValues,
            geo_lat: lat_lng.lat,
            geo_lng: lat_lng.lng,
            form_code: formCode
        };

        try{

            const response = await axios.post(
                `${UPDATE_FICHE}/${ficheData.id}`,
                finalValues
            );

            history.push(`/fiches/recapitulatif/${ficheData.code}`);

        } catch (e) {
            console.log(e);
        } finally {
            setIsSubmitting(false);

        }

    }


    return (
        <div className={`${classes.root} bg-white`}>

            <div className={`${classes.title} mb-5 font-weight-bolder h2`}>

                NOUVELLE DEMANDE

            </div>

            <NewFicheForm isSubmitting={isSubmitting} onUpdate={updateFiche} onFormSubmit={submitForm} />

        </div>
    );
}